import { UserAddress } from '../types/user.type';

export function getMainAddress(addresses?: UserAddress[]): UserAddress | undefined {
  if (!addresses || addresses.length === 0) return undefined;
  return addresses.find((address) => address.isMain) ?? addresses[0];
}
